import { render, staticRenderFns } from "./HomeworkStatus.vue?vue&type=template&id=52706e6a"
import script from "./HomeworkStatus.vue?vue&type=script&lang=js"
export * from "./HomeworkStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports